import { Reveal, SectionHeading } from "./Reveal";
import { ProductCard } from "./ProductCard";
import { useProducts } from "@/lib/products";

export const BestSellers = () => {
  const { products, bestSellerIds } = useProducts();
  const items = bestSellerIds.map((id) => products.find((p) => p.id === id)).filter(Boolean);

  return (
    <section id="cok-satanlar" data-testid="best-sellers-section" className="py-16 md:py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between gap-6">
          <SectionHeading
            eyebrow="Vitrin"
            title={<>Çok Satanlar —<br /><span className="italic text-emerald">en çok tercih edilenler</span></>}
            testId="best-sellers"
          />
          <Reveal delay={0.15} className="hidden md:block shrink-0">
            <p className="font-mono text-xs text-sage tracking-widest uppercase">Kaydır →</p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-10 md:mt-14">
          <div
            className="flex gap-5 md:gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-none pb-4 -mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
            data-testid="best-sellers-rail"
          >
            {items.map((p) => (
              <div key={p.id} className="snap-start shrink-0 w-[68vw] sm:w-[300px]">
                <ProductCard product={p} />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
